import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { LuCheck } from "@/Components/Icons/Icons"; // fallback
import { BlackButton } from "@/Components/Buttons/FiledButton";
import { useNavigate } from "react-router";

export default function SuccessMessage({ icon, label, onSubmit }) {
  const Icon = icon || LuCheck;
  const navigate = useNavigate();
  useEffect(() => {
    window.history.replaceState(
      null,
      "",
      `${import.meta.env.VITE_BASE_REDIRECT_URL}/login`
    );

    const handleBackButton = () => {
      navigate("/login", { replace: true });
    };

    window.addEventListener("popstate", handleBackButton);
    return () => window.removeEventListener("popstate", handleBackButton);
  }, [navigate]);
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={4}
      textAlign="center"
      mb={5}
      mt={5}
    >
      <Box
        sx={{
          width: 75,
          height: 75,
          borderRadius: "50%",
          backgroundColor: "var(--green-600)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
        }}
      >
        <Icon style={{ fontSize: 50, color: "var(--gray-0)" }} />
      </Box>

      <Typography
        fontSize="1.2rem"
        fontWeight={600}
        sx={{ color: "var(--brand-850)", lineHeight: 1.5 }}
      >
        {label}
      </Typography>
      <BlackButton label="Sign In" sx={{ mt: 7 }} onClick={onSubmit} width={"100%"} />
    </Box>
  );
}
